// extracted by mini-css-extract-plugin
module.exports =  {"container":"eKPDtmeGMhIke8pnqrDW","trophy":"mi8MYeFXxnBEiWT47Dag","rating":"G7sdUBO38W7FFuFaRoCW","ratingIcon":"aXvqydjy5K23FTo_qoiO"};